// extracted by mini-css-extract-plugin
export default {"quantity_container":"SO","hiddenflavorstring":"TO","loadingLine":"UO","productimgwrap":"VO","productimg":"WO","circlepic":"XO","productinfo":"YO","grey_x":"ZO","cartrow":"aP","bold":"bP","title":"cP","blue":"eP","strike":"fP","flexgap":"gP","flavorstring":"hP","nodecorate":"iP","flavorstring_link":"jP","rdstring":"kP","removeditemblock":"lP","removed_heading":"mP","removed_text":"nP","addback":"oP"};
    if(module.hot) {
      // 1721922365190
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  